import posthog from 'posthog-js';

export const getPostHog = () => {
    return posthog;
};

export const trackModalOpen = (modalName: string, organizationId: number | string | null, additionalProperties?: Record<string, any>) => {
    posthog.capture('modal_opened', {
        modal_name: modalName,
        organization_id: organizationId,
        ...additionalProperties,
    });
};